import RemoteAuthentication from '@security/data/usecases/RemoteAuthentication';
import AxiosHelper from '@shared/infra/protocols/http/AxiosHelper';
import constants from '@/Constants';

function CreateRemoteAuthentication(): RemoteAuthentication {
  return new RemoteAuthentication(AxiosHelper, constants.AUTH_URL);
}

export default CreateRemoteAuthentication;
